/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-14 10:28:42
 * @LastEditors: linguang linguang@nextmar.com
 * @LastEditTime: 2025-04-14 10:34:05
 * @FilePath: /zeelool-nextjs/src/components/Tooltip/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { EPlatform } from '@/utils/enums/platform-enum';
import { Tooltip as MuiTooltip, styled, tooltipClasses, TooltipProps } from '@mui/material';
import { ReactElement, useContext, useEffect, useRef, useState } from 'react';
import { ResponsiveContext } from '../Responsive/ResponsiveProvider';

interface CustomTooltipProps extends Omit<TooltipProps, 'children'> {
  children: ReactElement;
  trigger?: 'hover' | 'click';
  variant?: 'dark' | 'light';
  stopPropagation?: boolean;
  zIndex?: number;
  placement?:
    | 'auto-end'
    | 'auto-start'
    | 'auto'
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top';
  maxWidth?: number | string;
  backgroundColor?: string;
  onOpen?: () => void;
}

interface StyledTooltipProps extends TooltipProps {
  maxWidth?: number | string;
  backgroundColor?: string;
  zIndex?: number;
}

const CustomTooltip = styled(
  ({ className, maxWidth, backgroundColor, zIndex, ...props }: StyledTooltipProps) => (
    <MuiTooltip {...props} classes={{ popper: className }} />
  ),
)<StyledTooltipProps>(({ maxWidth = 280, backgroundColor = '#4D4D4D', zIndex }) => ({
  zIndex,
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor,
    color: '#fff',
    fontSize: 12,
    padding: '8px 12px',
    borderRadius: 4,
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    maxWidth,
    marginLeft: '8px !important',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: backgroundColor,
    '&::before': {
      backgroundColor,
    },
  },
}));

export default function Tooltip({
  children,
  trigger = 'hover',
  variant = 'dark',
  stopPropagation = true,
  placement = 'right-start',
  maxWidth,
  backgroundColor,
  onOpen,
  ...props
}: CustomTooltipProps) {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLSpanElement>(null);
  const { deviceType } = useContext(ResponsiveContext);

  // 将LightTooltip移到组件内部，这样可以正确访问deviceType
  interface LightStyledProps extends TooltipProps {
    zIndex?: number;
  }
  const LightTooltip = styled(({ className, ...tooltipProps }: LightStyledProps) => (
    // 跟UI确认的先用默认样式，只缩小底部间距
    <MuiTooltip
      {...tooltipProps}
      classes={{ popper: className }}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: deviceType === EPlatform.WEB ? [0, 0] : [0, 0],
              },
            },
          ],
        },
      }}
    />
  ))<LightStyledProps>(({ zIndex }) => ({
    zIndex,
    [`& .${tooltipClasses.tooltip}`]: {
      // 如果需要自定义样式，可以在这里添加
    },
  }));

  const TooltipComponent = variant === 'light' ? LightTooltip : CustomTooltip;

  const handleClose = () => {
    setOpen(false);
  };

  // 直接监听 document 点击事件来处理关闭
  useEffect(() => {
    if (trigger !== 'click' || !open) return;

    const handleDocumentClick = (event: MouseEvent) => {
      const target = event.target as Element;

      // 检查点击的是否是 tooltip 触发元素或其子元素
      const triggerElement = triggerRef.current;
      if (triggerElement && (target === triggerElement || triggerElement.contains(target))) {
        return;
      }

      // 检查点击的是否是任何 tooltip 内容
      const tooltipElements = document.querySelectorAll('[role="tooltip"]');
      let isClickingAnyTooltip = false;

      tooltipElements.forEach((tooltip) => {
        if (tooltip.contains(target)) {
          isClickingAnyTooltip = true;
        }
      });

      // 只有当前tooltip处于打开状态且点击的不是tooltip区域时才关闭
      if (!isClickingAnyTooltip) {
        handleClose();
      }
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        handleClose();
      }
    };

    // 延迟添加事件监听器，避免立即触发
    const timer = setTimeout(() => {
      document.addEventListener('click', handleDocumentClick, true);
      document.addEventListener('keydown', handleKeyDown);
    }, 100);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('click', handleDocumentClick, true);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [trigger, open]);

  // 监听 open 状态变化，当从 false 变为 true 时触发 onOpen 回调
  const prevOpenRef = useRef(open);
  useEffect(() => {
    if (open && !prevOpenRef.current && onOpen) {
      onOpen();
    }
    prevOpenRef.current = open;
  }, [open, onOpen]);

  const handleToggle = (e: React.MouseEvent) => {
    if (stopPropagation) {
      e.stopPropagation();
    }
    e.preventDefault();
    setOpen((prev) => !prev);
  };

  // 只有在dark variant时才传递maxWidth和backgroundColor
  const customProps = variant === 'dark' ? { maxWidth, backgroundColor } : {};

  if (trigger === 'click') {
    return (
      <span
        ref={triggerRef}
        onClick={handleToggle}
        style={{ display: 'inline-flex', alignItems: 'center' }}
      >
        <TooltipComponent
          arrow
          placement={placement}
          open={open}
          onClose={handleClose}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          {...customProps}
          {...props}
        >
          {children}
        </TooltipComponent>
      </span>
    );
  }

  return (
    <TooltipComponent arrow placement={placement} {...customProps} {...props}>
      {children}
    </TooltipComponent>
  );
}
